export default {
	label: {
		username: 'Username'
	}
}  